import React, { useState,useEffect } from "react";
import { AutoComplete } from 'primereact/autocomplete';


const SeleccionHembrasA01a = (props) => {
console.log(props)
  const [selectedAutoValue, setSelectedAutoValue] = useState(props.CHIP_MACHO);
  const [autoFilteredValue, setAutoFilteredValue] = useState([]);
  const [autoValue, setAutoValue] = useState([]);
  const [reload, setReload] = useState(true)
  const APITABLASBASICAS = 'https://www.ancogenecop.com/APIANCO/controllers/selecciones.php?op='

  useEffect(() => {
    async function traerUsuarios(CONSECUTIVO_SERVICIO) {
        const data = new FormData();
        data.append('CONSECUTIVO',CONSECUTIVO_SERVICIO)
      await fetch(APITABLASBASICAS + 'SeleccionHembrasA01a', {
        method: 'POST',
        header: {
          'Accept': 'application/json',
          'Content-type': 'application/json'
        },
        body: data
      }).then((response) => response.json())
        .then((response) => {
            setReload(false)
            setAutoValue(response)
        })
        .catch((error) => {
          console.log(error);
        })
    }
    traerUsuarios(props.CONSECUTIVO_SERVICIO)
}, [reload,props.CONSECUTIVO_SERVICIO]);


  const searchCountry = (event) => {
    setTimeout(() => {
        if (!event.query.trim().length) {
            setAutoFilteredValue([...autoValue]);
        }
        else {
            setAutoFilteredValue(autoValue.filter((a) => {
                return a.name.toUpperCase().startsWith(event.query.toUpperCase());
            }));
        }
    }, 250);
};



  const handleChange = (event) => {
    setSelectedAutoValue(event)
    return props.handleplanta(event.code,160)
  };



  return (
    <div className="p-error">
      <AutoComplete placeholder="Buscar" id="dd" dropdown value={selectedAutoValue}
      onChange={(e) => handleChange(e.value)}
      suggestions={autoFilteredValue} completeMethod={searchCountry} field="name" />
    </div>
  );
};

export default SeleccionHembrasA01a;
